import { deleteApi, putApi, FILE_BASE_URL } from "./apiService";

export const uploadSingleFile = async (file) => {
    const formData = new FormData();
    formData.append("file", file);

    try {
        const response = await putApi("/file/upload-single", formData, {
            headers: { "Content-Type": "multipart/form-data" },
        });
        const base = FILE_BASE_URL.replace(/\/$/, "");
        return { fileName: response.fileName, fileUrl: `${base}/${response.fileName}` };
    } catch (error) {
        console.error("Error uploading single file:", error);
        throw error;
    }
};

export const uploadMultipleFiles = async (files) => {
    //files)
    const formData = new FormData();
    files.forEach((file) => formData.append("files", file));

    try {
        const response = await putApi("/file/upload-multiple", formData, {
            headers: { "Content-Type": "multipart/form-data" },
        });
        return response.fileNames// Return full URLs
    } catch (error) {
        console.error("Error uploading multiple files:", error);
        throw error;
    }
};

export const removeFile = async (fileName) => {
    try {
        return await deleteApi(`/file/remove-single/${fileName}`);
    } catch (error) {
        console.error("Error removing file:", error);
        throw error;
    }
};
